module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keyword":"Keyword","value":"Value","enter_value":"Enter value"},"fr":{"keyword":"Mot clé","value":"Valeur","enter_value":"Entrez valeur"},"de":{"keyword":"Stichwort","value":"Wert","enter_value":"Wert eingeben"}}')
  delete Component.options._Ctor
}
